const formatPrice = (amount) => {
    const settings = {
        style: 'currency',
        currency: window.config.currency.code,
        useGrouping: true,
    };

    settings.minimumFractionDigits = 0;
    settings.maximumFractionDigits = 0;

    // ! If you want to change settings, edit formatPrice backend method too. They must be compatible.
    const str = new Intl.NumberFormat(window.config.language.locale, settings).format(amount);

    return str;
};

export default formatPrice;
